import { render } from "./AddNode.vue?vue&type=template&id=5960daf3"
import script from "./AddNode.vue?vue&type=script&lang=js"
export * from "./AddNode.vue?vue&type=script&lang=js"
script.render = render

export default script